// src/api/user-management-api.ts
import { userManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { ISO3LanguageCode, ZitadelUser } from "@src/types/user-management";

export const patchUserLanguage = async (
  namespace: string,
  userId: string,
  language: ISO3LanguageCode,
) => {
  const url = userManagerUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.patch<ZitadelUser>(
      `${url}/api/v1/ns/${namespace}/users/human/${userId}`,
      { language: language },
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to update user. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error("An unexpected error occurred while updating user.");
    }
  }
};
